import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import Banner from '../Banner';


function BannerPrincipal({item,DadosAPI }) {

    
    return(
        <>
            <Banner Item={item.banners[0]}/>
        </>
    )
     
}

export default BannerPrincipal;
